export default __webpack_public_path__ + "static/media/wireframeimg.d9d783d5.webp";